export default __webpack_public_path__ + "static/media/H520753_tn.8b3504ed.jpg";